import React from "react";
import { createCallable } from "react-call";
import { ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { EdgenModal, EdgenModalProps } from "../EdgenModal";
import { ShareContent } from "./ShareContent";
import Translations from "@translate/components/Chat/SharePreviewModal";
import { I18nUtil } from "@utils";
import { SHARE_PREVIEW_MODAL_MAX_WIDTH_PX } from "./sharePreview.constants";
import styles from "./sharePreview.module.css";

const I18n = I18nUtil.createScoped(Translations);

// 组件 Props 接口
export interface SharePreviewModalProps {
  shareUrl: string;
  onClose?: () => void;
}

// SharePreviewModal 可调用版本的 Props（基于 EdgenModal）
export type SharePreviewModalCreateAbleProps = Omit<
  EdgenModalProps,
  "open" | "onClose" | "children"
> &
  SharePreviewModalProps;

// SharePreviewModal 可调用版本（基于 EdgenModal 和 react-call）
export const SharePreviewModalCreateAble = createCallable<
  SharePreviewModalCreateAbleProps,
  void
>(({ call, shareUrl, onClose, ...modalProps }) => {
  const {
    classNames: modalClassNames,
    styles: modalStyles,
    ...restModalProps
  } = modalProps;

  return (
    <EdgenModal
      {...restModalProps}
      open={true}
      onClose={() => {
        call.end();
        onClose?.();
      }}
      title={I18n.t("Share Preview")}
      titleClassName="headline_regular_m text-content_primary mb-6 p-0"
      centered={true}
      destroyOnClose={true}
      width={SHARE_PREVIEW_MODAL_MAX_WIDTH_PX}
      classNames={{
        ...modalClassNames,
        wrapper: cn(styles.modalWrap, modalClassNames?.wrapper),
      }}
      containerClassName={cn(
        styles.modalContainer,
        restModalProps.containerClassName,
      )}
      containerStyle={{
        maxHeight: "742px",
        ...restModalProps.containerStyle,
      }}
      styles={{
        ...modalStyles,
        content: {
          ...modalStyles?.content,
          padding: "24px 24px",
          borderRadius: "16px",
          maxHeight: "742px",
          backgroundColor: ospThemes.colors.background_solid_tertiary,
          width: "100%",
          maxWidth: "100%",
        },
      }}
    >
      <ShareContent
        shareUrl={shareUrl}
        onClose={() => {
          call.end();
          onClose?.();
        }}
      />
    </EdgenModal>
  );
});

export default SharePreviewModalCreateAble;
